import './PayButton.css';

interface PayButtonProps {
    onClick: () => void;
    disabled?: boolean;
    loading?: boolean;
    label?: string;
}

function PayButton({ onClick, disabled = false, loading = false, label = 'Pay Now' }: PayButtonProps) {
    return (
        <button
            type="button"
            className="pay-button"
            onClick={onClick}
            disabled={disabled || loading}
        >
            {loading && <span className="pay-spinner" aria-hidden="true" />}
            {loading ? 'Processing...' : label}
        </button>
    );
}

export default PayButton;
